import instance from "api/instance";

const profile = async () => {
	const response = await instance.get("/subreseller/profile");
	if (response.status === 200) {
		return response.data;
	}
	
	return Promise.reject(response.data);
};


const update = async (data) => {
	const response = await instance.patch("/subreseller/profile",data);
	if (response.status === 200) {
		return response.data;
	}
	
	return Promise.reject(response.data);
};



const profileService = {
	profile,
	update
};

export default profileService;